<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Submission Report Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading class="mb-3">
      <span class="float-left mr-2"
        >{{ submission.publicNumber() }} Report</span
      >
      <template #right-content>
        <header-button-group
          :button_config="button_config"
          @dropdownAction="selectReportType"
        />
      </template>
    </basic-heading>
    <submission-report
      :report="report"
      :report_type="report_type"
      :submission="submission"
    />
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import SubmissionReport from "@/components/lab/submission/report/SubmissionReport";
import { getModel } from "@/shared/fetch-utils";
import { ReportTypes } from "@/reports/report_factory";
import { getReportType } from "@/shared/utils";

export default {
  name: "SubmissionReportDetail",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    SubmissionReport,
  },
  data() {
    return {
      loading: true,
      submission_id: this.$route.params.submission_id || null,
      submission: null,
      report_type: null,
      current_report: {},
    };
  },
  computed: {
    button_config() {
      return {
        dropdown: {
          with_action: true,
          items: [
            {
              action_data: "Feed",
              text: "Feed report",
            },
            {
              action_data: "Soil",
              text: "Soil report",
            },
            {
              action_data: "Feed Mixer Efficiency",
              text: "Feed Mixer Efficiency report",
            },
            {
              action_data: "Irrigation Suitability",
              text: "SAR report",
            },
            {
              action_data: "Septic Soil",
              text: "Septic report",
            },
            {
              action_data: "Tissue",
              text: "Tissue report",
            },
            {
              action_data: "Water",
              text: "Water report",
            },
            {
              action_data: "Potato",
              text: "Potato report",
            },
          ],
        },
      };
    },
    current_report_test() {
      return ReportTypes.get(getReportType(this.report_type), this.submission_id);
    },
    report() {
      const { lab, report, samples, results } = this.current_report;
      // const { lab, report, samples, results } = this.current_report_test;

      return {
        header: {
          lab,
          report,
        },
        samples: samples || results,
        footer: {
          approved_by: report.approved_by,
          bdl: report.bdl,
          notes: report.notes,
        },
      };
    },
  },
  methods: {
    selectReportType(type) {
      this.report_type = type;
    },
  },
  async created() {
    this.loading = true;

    this.submission = await getModel({
      model_type: "submission",
      id: this.submission_id,
      message: this.$bvToast,
    });

    // set the report type based on the submission type
    // this will dictate which report type will open
    this.report_type = this.submission.sample_type.name;

    const submissionDetails = await this.submission.submissionReport();
    this.current_report = submissionDetails.response.data.data;

    this.loading = false;
  },
};
</script>

<style>
.report-wrapper {
  min-width: fit-content;
}
</style>
